import React from 'react';
import { Formik, FormikProps, Form, Field } from 'formik';
import FormInput from 'shared/Inputs/Inline/FormInput';
import Button from 'shared/Button/Button';
import FullAddress from 'components/Forms/Address/Templates/FullAddress';
import { AdviserDetailsProps } from './interface/AdviserDetailsInterface';
import { adviserDetailsSchema } from './validator/AdviserDetailsValidator';
import { formatFullAddress } from 'utils/address/index';
import './_AdviserDetails.scss';
import { populateAddressHandlerNumberConcat } from 'utils/address/form';

const AdviserDetails: React.FC<AdviserDetailsProps> = ({ details, onSubmit, isSaved }) => {
  const onContactNumberChange = (setFieldValue: any, values: any) => {
    setFieldValue('edit.contactNumber', !values.edit.contactNumber);
  };

  const onAddressChange = (setFieldValue: any, values: any) => {
    setFieldValue('edit.address', !values.edit.address);
    setFieldValue('fullAddress', formatFullAddress(values.address));
  };

  const onEmailChange = (setFieldValue: any, values: any) => {
    setFieldValue('edit.email', !values.edit.email);
  };

  return (
    <Formik
      initialValues={details}
      onSubmit={onSubmit}
      validationSchema={adviserDetailsSchema}
      enableReinitialize={true}>
      {({ values, setFieldValue, errors, touched }: FormikProps<any>) => {
        const isValid = (fieldName: string) => !!(errors && errors[fieldName] && touched && touched[fieldName]);
        const isCorrect = (fieldName: string) =>
          Boolean(!(errors && errors[fieldName]) && touched && touched[fieldName]);

        return (
          <>
            <Form className="form register-firm adviser-details">
              <h2 className="adviser-details__h1">Adviser Details</h2>
              <Field
                name="fullName"
                component={FormInput}
                label="Name"
                readOnly={true}
                wrapperClass={'form__wrapper inline border bottom'}
              />

              <Field
                name="firm_name"
                component={FormInput}
                label="Company"
                readOnly={true}
                wrapperClass={'form__wrapper inline border bottom'}
              />

              <Field
                name="fca.number"
                component={FormInput}
                label="FCA Number"
                readOnly={true}
                wrapperClass={'form__wrapper inline border bottom'}
              />

              <Field
                name="fullAddress"
                component={FormInput}
                label="Address"
                readOnly={true}
                inputWidth={8}
                buttonWidth={4}
                buttonClass="button"
                onChangeClick={() => onAddressChange(setFieldValue, values)}
                wrapperClass={'form__wrapper inline border bottom'}
              />

              {values.edit.address && (
                <FullAddress
                  isValid={isValid}
                  isCorrect={isCorrect}
                  prefix="address"
                  requiredFields={{}}
                  onSelect={populateAddressHandlerNumberConcat(setFieldValue)}
                  showFlatNumber={false}
                />
              )}

              <Field
                name="email"
                component={FormInput}
                label="Email Address"
                inputWidth={8}
                buttonWidth={4}
                buttonClass="button"
                onChangeClick={() => onEmailChange(setFieldValue, values)}
                readOnly={!values.edit.email}
                type="email"
                wrapperClass={'form__wrapper inline border bottom'}
              />

              <Field
                name="phone"
                component={FormInput}
                label="Contact No."
                inputWidth={8}
                buttonWidth={4}
                buttonClass="button"
                onChangeClick={() => onContactNumberChange(setFieldValue, values)}
                readOnly={!values.edit.contactNumber}
                wrapperClass={'form__wrapper inline border bottom'}
              />

              <div className="details-row">
                <Field name="fcaStatus" component={FormInput} label="FCA Status" inputWidth={8} readOnly={true} />
                <Field name="lmcStatus" component={FormInput} label="LMC Status" inputWidth={8} readOnly={true} />
              </div>

              <div className="form__navigation">
                {isSaved && <span className="form-saved align-center">Saved!</span>}
                <Button className="form__submit" type="submit" label="Save" />
              </div>
            </Form>
          </>
        );
      }}
    </Formik>
  );
};

export default AdviserDetails;
